<template>
  <div>
    <icon-view
      class="mr-2 mt-3 rounded-circle icon-view-color-text"
      icon="fas fa-user-tag mb-1"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      title="Información de Parentesco"
      :gradient="true"
    />
    <div v-for="(item, index) in listOfModel" :key="index">
      <relationship-information
        :ref="'rel' + index"
        :info="item"
        :relationships="relationships"
        :readOnly="readOnly"
        :index="index + 1"
        @input="setInfo(item, $event)"
      />
    </div>
  </div>
</template>

<script>
import IconView from "icon-view";
import RelationshipInformation from "./RegistrationRelationshipInformation";
export default {
  name: "ListOfRegistrationRelationship",
  components: {
    IconView,
    RelationshipInformation
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    relationships: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      listOfModel: [],
      itemRefs: []
    };
  },
  methods: {
    setInfo(item, info) {
      const index = this.listOfModel.indexOf(item);
      if (index > -1) this.listOfModel[index] = info;
    },
    setItemRef(el) {
      if (el) {
        this.itemRefs.push(el);
      }
    },
    async validate() {
      let countOfValid = 0;
      Object.keys(this.$refs).forEach(async el => {
        const isValid = await this.$refs[
          el
        ][0].$refs.relationshipForm.validate();
        if (!isValid) {
          countOfValid++;
        }
      });
      return countOfValid == 0;
    }
  },
  watch: {
    list: {
      handler(value) {
        this.listOfModel = value;
      }
    },
    listOfModel: {
      handler(value) {
        this.$emit("input", value);
      }
    }
  },
  beforeUpdate() {
    this.itemRefs = [];
  }
};
</script>

<style lang="scss" scoped></style>
